var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{staticClass:"static-page"},[_c('div',{staticClass:"static-page__content"},[_c('section',{staticClass:"static-page__descr",domProps:{"innerHTML":_vm._s(_vm.pageData.description1)}}),_c('section',{staticClass:"static-page__descr",domProps:{"innerHTML":_vm._s(_vm.pageData.description2)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }